import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const World_1: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 1600,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // all
					d="M338 144.94a139.89 139.89 0 00-8.6-14.07 142.84 142.84 0 00-235.43.42 139.21 139.21 0 00-8.52 14.07 143 143 0 00-.68 131.93 138.15 138.15 0 009.18 15.36 142.85 142.85 0 00235.56.31 137.42 137.42 0 009.19-15.3 143 143 0 00-.7-132.72zm-29.58-9.73c-11.77 2.13-24.1 3.89-36.88 5.23-5.19-18.23-12.31-33.9-20.8-45.83a123.35 123.35 0 0157.64 40.6zm-150.67 67.73a261.8 261.8 0 015.06-45.15c15.49 1.27 31.55 1.93 48 1.93 15.88 0 31.37-.61 46.33-1.79a263.54 263.54 0 015 45zm104.4 18.44a262.3 262.3 0 01-5 43.15 592.531 592.531 0 00-46.23-1.79c-16.54 0-32.65.67-48.17 1.95a261.92 261.92 0 01-5-43.31zm-55.54-133a22 22 0 016-.1c16.88 2 31.66 22.84 40.6 53.76-13.77 1-28 1.52-42.52 1.52-15.07 0-29.8-.55-44.05-1.63 8.9-30.43 23.36-51.07 39.97-53.54zM171.5 95c-8.39 11.9-15.43 27.47-20.57 45.58-12.56-1.3-24.68-3-36.26-5.06A123.3 123.3 0 01171.5 95zM105 149.78c13.31 2.67 27.41 4.86 42.12 6.49a269.73 269.73 0 00-5.35 46.67h-53A122.43 122.43 0 01105 149.78zm-.22 123a122.48 122.48 0 01-15.92-51.38h53a270.32 270.32 0 005.2 44.85c-14.82 1.61-28.96 3.8-42.31 6.51zm10.61 15.54c11.46-2 23.43-3.7 35.84-5 5.12 17.69 12.06 32.94 20.3 44.64a123.25 123.25 0 01-56.17-39.66zM210 334.44c-17.74 0-33.43-20.76-42.9-52.53 14.22-1.06 28.91-1.62 43.95-1.62 14.31 0 28.3.51 41.87 1.47-9.48 31.85-25.17 52.68-42.92 52.68zm40.72-6.13c8.35-11.73 15.38-27.09 20.54-44.94 12.64 1.3 24.86 3 36.51 5.13a123.31 123.31 0 01-57.07 39.81zM318.37 273c-13.53-2.78-27.91-5-42.92-6.71a267.51 267.51 0 005.21-44.9h53.76A122.31 122.31 0 01318.37 273zm-37.66-70.05a269.68 269.68 0 00-5.36-46.76c14.95-1.67 29.27-3.93 42.76-6.68a122.25 122.25 0 0116.41 53.44z"
				/>
			</svg>
		</animated.span>
	)
}

export { World_1 }
